<div *ngFor="let modal of modalList" class="app-modal">

    <app-modal-flight-direction
      *ngIf="modal.modalType === 'flightDirection'"
      [modalData]="modalData">
    </app-modal-flight-direction>

    <app-modal-flight-search
      *ngIf="modal.modalType === 'flightSearch'"
      [modalData]="modalData">
    </app-modal-flight-search>

    <app-flight-info-modal
      *ngIf="modal.modalType === 'flightInfo'"
      [modalData]="modalData">
    </app-flight-info-modal>

    <app-associated-flights *ngIf="modal.modalType === 'associatedFlight'"
    [modalData]="modalData">
    </app-associated-flights>

    <div class="modal-backdrop"></div>
    <div *ngIf="modal.showLoader" class="loader-container">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>

</div>
